<template>
  <div class="c-table" ref="materialTable">
    <el-table
      class="common-el-table-styles"
      ref="table"
      :data="data"
      :height="height"
      border
      stripe
      @sort-change="sortChange"
      @row-click="rowClick"
      @selection-change="changeSelection"
    >
      <el-table-column type="selection" width="47" align="center"></el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'uploadTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <Tooltip v-else-if="col.key === 'imageName'" :delay="1000" placement="top-start" transfer>
            <a href="javascript:;">{{ scope.row[col.key] }}</a>
            <div class="m-tooltip-content" slot="content">
              <video v-if="scope.row.type === 2" :src="scope.row.addr" controls="controls" />
              <img v-else :src="scope.row.addr" />
            </div>
          </Tooltip>
          <span v-else-if="['pv', 'clickNum', 'amount'].includes(col.key)">
            {{ scope.row[col.key] | toThousands }}
          </span>
          <span v-else-if="col.key.indexOf('Rate') > -1 || col.key.indexOf('Roi') > -1">
            {{ scope.row[col.key] | toPercentFixed }}
          </span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout, deepCopy, uniqueArray } from '@/common/js/utils'
export default {
  name: 'targetingTable',

  props: {
    value: {
      type: Array
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Object
    },
    type: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selection: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    rowClick(row, column) {
      if (!this.multiple) this.$refs.table.clearSelection() // 单选清空
      const selection = deepCopy(this.selection)
      const checked = selection.map((ret) => ret.id).includes(row.id)
      if (checked) {
        const index = selection.findIndex((ret) => ret.id === row.id)
        selection.splice(index, 1)
        this.$refs.table.toggleRowSelection(row)
      } else {
        selection.push(row)
        this.$refs.table.toggleRowSelection(row, true)
      }
      this.changeSelection(selection)
    },
    changeSelection(selection) {
      this.$emit('input', uniqueArray([...selection, ...this.value], 'id'))
    }
  },
  data() {
    return {
      height: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      timeout(0).then(() => {
        this.height = this.$refs.materialTable.offsetHeight - 16
        this.$refs.table.doLayout()
      })
    })
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  height: 100%;
  background-color: #fff;

  ::v-deep .el-table {
    background-color: #fff;

    .el-table-column--selection {
      position: relative;

      &.is-leaf {
        .cell {
          display: none;
        }
      }
      .cell {
        .el-checkbox {
          pointer-events: none;
        }
      }
    }

    .cell {
      line-height: 20px;
    }
  }

  .c-control-margin {
    margin: 0;
    padding-right: 6px;
  }
}

.target-tooltip {
  position: relative;
  background: #ff6600;

  .target-close {
    position: absolute;
    top: 18px;
    right: 12px;
  }

  .target-wrap {
    width: 280px;

    header {
      width: inherit;
      padding: 8px 0 8px 8px;
      border-bottom: solid 1px #dedede;

      dl {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        line-height: 26px;
        font-size: 14px;
        color: #333;
        font-weight: bold;
        margin: 0;
      }
    }

    .target-content {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      padding: 8px 0 8px 4px;
      width: 100%;
      max-height: 318px;

      ul {
        margin: 0;
      }

      li {
        padding-top: 6px;
        display: flex;

        dd,
        dt {
          line-height: 18px;
          display: inline-block;
          margin: 0;
        }

        dt {
          color: #333;
          font-weight: 600;
        }

        dd {
          max-width: 230px;
          word-break: break-all;
          white-space: normal;
          color: #888;
        }
      }
    }
  }
}
</style>
